import { render } from "./index.vue?vue&type=template&id=7ef05a96&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=7ef05a96&lang=scss"

import exportComponent from "/root/workspace/sso-webclient_Xaij/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__